module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_82.862e5eaf.jpg";